import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetVideo } from 'src/app/k-video/k-video.actions';
import { KVideoState } from 'src/app/k-video/k-video.model';
import { streams } from 'src/app/k-video/k-video.selectors';
import { DidStep, SelectToolOpts, SignerLic, SignerPic } from '../../canvas.actions';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { PagesState } from 'src/app/pages/pages.model';
import { showAsset } from 'src/app/pages/pages.selectors';

import { progress, selSignerKey } from '../../canvas.selectors';
import { WSSService } from 'src/app/wss/wss.service';
import { CanvasUploaderService } from '../../canvas-uploader.service';

@Component({
  selector: 'get-user-id',
  templateUrl: './get-user-id.component.html',
  styleUrls: ['./get-user-id.component.scss']
})
export class GetUserIdComponent {
  img_src: string = ""
  img_type: string = "image/png"
  crop_prompt: string = ""
  @ViewChild('videoElement') videoCapture: ElementRef | undefined;

  @Input() target: string = "user";
  bHandlersReady: boolean = false
  @ViewChild('viewPort') viewPort: ElementRef | undefined;
  @ViewChild('topLeft') topLeft: ElementRef | undefined;
  @ViewChild('topRight') topRight: ElementRef | undefined;
  @ViewChild('bottomLeft') bottomLeft: ElementRef | undefined;
  @ViewChild('bottomRight') bottomRight: ElementRef | undefined;


  prompt: string = "Take the picture"
  blob: Blob | undefined
  hide_video: boolean = false;
  done_color: string = "#ECECEC"
  text_color: string = "#151515"


  left: number = -100;
  top: number = 0;
  bottom: number = 0;
  right: number = -100;
  bTakePic: boolean = false
  stream: MediaStream | undefined


  bShowSpinner: boolean = false;
  uploader: FileUploader | undefined
  contract_id: string | undefined
  progress: number = 0
  next_text: string = "Next"

  signer_key: string | undefined;
  subscriptions: any[] = []

  constructor(
    public upload_service: CanvasUploaderService,
    private kVideoState: Store<KVideoState>,
    public canvasStore: Store<CanvasState>,
    private pagesState: Store<PagesState>,
    public wss_service: WSSService,
  ) {
    console.log("get user id")
    this.kVideoState.dispatch(new SetVideo(true))
    this.subscriptions.push(this.canvasStore.select(progress).subscribe((progress: any) => {
      this.progress = progress.progress
      if (this.progress == 100) {
        this.next_text = "Done"
      }
    }))

    this.subscriptions.push(this.canvasStore.select(selSignerKey).subscribe((signer_key: string | undefined) => {
      this.signer_key = signer_key
    }))

    this.subscriptions.push(this.pagesState.select(showAsset).subscribe((asset: any) => {
      if (asset) {
        if (asset.type == "contract") {
          this.contract_id = asset._id
          this.setUpLoader()
        }
      }
    }))
  }
  ngOnDestroy() {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  ngAfterViewInit() {
    this.subscriptions.push(this.kVideoState.select(streams).subscribe((streams: any) => {
      let stream = streams["me"]
      if (stream) {
        this.stream = stream
      }
    }))
    // let lic_src = localStorage.getItem("lic_src")
    // if (lic_src) {
    //   this.img_src = lic_src
    // }
  }


  setMouseHandlers() {
    let me = this
    let target: any | undefined
    let mouse_x: number = 0;
    let mouse_y: number = 0

    let orig_left: number = 0;
    let orig_top: number = 0

    function onAnchorMouseDown($event: any) {
      $event.preventDefault()
      target = $event.currentTarget;
      if (me.viewPort) {
        me.viewPort.nativeElement.focus()
      }
      mouse_x = $event.clientX
      mouse_y = $event.clientY

      orig_left = target.offsetLeft
      orig_top = target.offsetTop
      console.log("#Anchor down " + target.dataset.id)

    }

    function onViewPortMouseMove($event: any) {
      if (target) {
        let delta_x = mouse_x - $event.clientX
        let delta_y = mouse_y - $event.clientY
        let left = orig_left - delta_x
        let top = orig_top - delta_y
        console.log("#Anchor move " + target.dataset.id)
        if (target.dataset.id == "bottomRight") {
          me.right = left
          me.bottom = top
        } else if (target.dataset.id == "bottomLeft") {
          me.left = left
          me.bottom = top
        } else if (target.dataset.id == "topLeft") {
          me.left = left
          me.top = top
        } else if (target.dataset.id == "topRight") {
          me.right = left
          me.top = top
        }
      }
    }

    function onViewPortMouseUp($event: any) {
      console.log("#Anchor up " + target.dataset.id)
      target = undefined
    }


    function setAnchorMouseHandler(el: ElementRef | undefined, label: string) {
      if (el) {
        el.nativeElement.dataset.id = label
        el.nativeElement.addEventListener('touchstart', onAnchorMouseDown, false);
        el.nativeElement.addEventListener('pointerdown', onAnchorMouseDown, false);

        el.nativeElement.addEventListener('touchstart', onAnchorMouseDown, false);
        el.nativeElement.addEventListener('pointerdown', onAnchorMouseDown, false);
      }
    }
    if (this.viewPort) {
      this.bHandlersReady = true
      this.bottom = this.viewPort.nativeElement.clientHeight - 10;
      this.right = this.viewPort.nativeElement.clientWidth - 10;

      this.viewPort.nativeElement.addEventListener('touchend', onViewPortMouseUp, false);
      this.viewPort.nativeElement.addEventListener('pointerup', onViewPortMouseUp, false);

      this.viewPort.nativeElement.addEventListener('pointermove', onViewPortMouseMove, false);
      this.viewPort.nativeElement.addEventListener('touchmove', onViewPortMouseMove, false);

      setAnchorMouseHandler(this.topLeft, 'topLeft')
      setAnchorMouseHandler(this.topRight, 'topRight')
      setAnchorMouseHandler(this.bottomLeft, 'bottomLeft')
      setAnchorMouseHandler(this.bottomRight, 'bottomRight')
    }
  }

  async takeThePic() {
    this.done_color = "#000"//"#40BE5C"
    this.text_color = "#FFF"

    if (this.prompt == "Take it again") {
      this.prompt = "Take the picture"
      this.hide_video = false;
      return
    }


    if (this.videoCapture) {
      var canvas = document.createElement('canvas');
      canvas.id = "CursorLayer";
      canvas.width = 480
      canvas.height = 360

      canvas.style.position = "absolute";
      var context = canvas.getContext("2d");
      if (context && this.videoCapture) {
        context.imageSmoothingEnabled = false;



        context.drawImage(this.videoCapture.nativeElement,
          80, 60, 480, 360,  // sx, sy, sWidth, sHeight,  640x480
          0, 0, 480, 360); // dx, dy, dWidth, dHeight


        this.img_src = canvas.toDataURL("image/png")
        this.hide_video = true;
        this.prompt = "Take it again"
      }
    }
  }

  async  done() {
    // this.cropImage()
    if (this.img_src) {
      console.log("take pic " + this.img_src.length)
      // let imageBytes: ArrayBuffer = await base64ToFile(this.img_src)
      // var byteArray = new Uint8Array(imageBytes);
      // this.blob = new Blob([byteArray]);
      this.canvasStore.dispatch(new SignerLic(this.img_src, this.img_type))
      this.canvasStore.dispatch(new DidStep("driver_lic"))
      let jmsg: any = {
        caller_lic: this.img_src,
        signer_key: this.signer_key,
        img_type: this.img_type
      }
      this.wss_service.sendMessageToOtherMembers(jmsg)

    }
  }
  cancel() {
    this.canvasStore.dispatch(new SelectToolOpts(""))
    this.canvasStore.dispatch(new DidStep(""))
  }

  async takingPic() {
    function delay(ms: number) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    this.bTakePic = true
    let bWaitingForStream: boolean = true
    do {
      await delay(100)
      if (this.videoCapture && this.stream) {
        let vt = this.stream.getVideoTracks()
        if (vt.length > 0) {
          this.videoCapture.nativeElement.srcObject = this.stream//caller for caller
          bWaitingForStream = false
        }
      }
    } while (bWaitingForStream)
  }
  fileToUpload: File | null = null;
  handleFileInput(_evt: any) {

    let files: FileList = _evt.target.files
    this.fileToUpload = files.item(0);

    console.log("Selected to upload")
    this.bShowSpinner = true;
    if (this.uploader) {
      this.uploader.uploadAll();
    }
  }
  dropped($event: any) {
    console.log("dropped file")
    console.log("Selected to upload")
    this.bShowSpinner = true;
    if (this.uploader) {
      this.uploader.uploadAll();
    }
  }
  // @HostListener('drop', ['$event'])
  // public onDrop(event: any): void {
  //   event.preventDefault();
  //   event.stopPropagation();
  // }
  setUpLoader() {

    this.uploader = this.upload_service.setUpUploader("image") //This will bounce it back
    this.uploader.onCompleteItem = async (item: FileItem, response: string, status: number, _header: any) => {
      if (status == 200) {
        // let picture = JSON.parse(rsponse)
        this.bShowSpinner = false
        this.img_type = item._file.type
        this.img_src = 'data:image/jpeg;base64,' + response //picture.url
        this.done_color = "#000"//"#40BE5C"
        this.text_color = "#FFF"
        // "key": jres.key,
        // "url": jres.url,
        // "exp": jres.exp

      }

    }
  }
  rotate() {
    if (this.img_src) {
      const img = new Image();
      img.src = this.img_src
      let me = this
      img.onload = function(el: any) {
        console.log("width " + el.target.width)
        console.log("height " + el.target.height)
        const canvas = document.createElement('canvas');
        canvas.width = el.target.height
        canvas.height = el.target.width
        const ctx = canvas.getContext('2d');
        if (ctx) {
          // ctx.save();
          // translate and rotate
          ctx.translate(canvas.width, canvas.height / canvas.width);
          ctx.rotate(Math.PI / 2);
          // draw the previows image, now rotated

          ctx.drawImage(el.target, 0, 0);
          me.img_src = ctx.canvas.toDataURL('image/jpeg', 1);
        }
      }
    }
  }
  undo() {
    this.bTakePic = false
    this.img_src = ""
  }
}
